import './styles/LoadData.css'
import { capitalizeFirstLetter } from '../utils/utils'
import { lang } from './generales/traduction'

const LoadData=({mode,languaje})=>{
    return(
        <div className='LoadContent'>
            <div className='compactLoadItems'>
                
                <div className='loadCont iconLoadCont'>
                    {/* <span className='loader'></span> */}
                    <div className={"loader"+mode}>
                        <span></span>
                    </div>
                </div>
                <div className=' loadCont textLoadCont'>
                    <div className={'txtLoader'+mode}>{capitalizeFirstLetter(lang[languaje]['obteniendoDatos'])}. . .
                    {/* <span className="blink_me" id="rotate">
                        <span>.</span>
                        <span>..</span>
                        <span>...</span>
                    </span>  */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoadData